import { useOrderDetailContext } from '@euler/app/flows/order/components/OrderDetailProvider';
import { ServiceSubjectCell } from '@euler/app/flows/order/pages/OrderScreen/form/rows/ServiceSubjectsRow';
import { sortedServiceSubjectsByType } from '@euler/app/flows/order/util/sortedServiceSubjectsByType';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useMemo } from 'react';
import { OrderInfoSection as Section } from './Section';

export const ServiceSubjectSection = memo(() => {
  const { rpx } = useResponsiveContext();
  const styles = useStyles();
  const { orderDetail } = useOrderDetailContext();

  if (!orderDetail?.serviceSubjects?.length) {
    return null;
  }

  return (
    <Section title="服务项目">
      {sortedServiceSubjectsByType(orderDetail.serviceSubjects).map(
        (subject, index) => (
          <ServiceSubjectCell
            subject={subject}
            index={index}
            key={index}
            nameStyle={styles.serviceSubject.name}
            labelStyle={styles.serviceSubject.label}
            css={`
              border-top-width: 0;
              border-bottom-width: ${index ===
              orderDetail!.serviceSubjects!.length - 1
                ? 0
                : 1}px;
              border-bottom-color: rgb(241, 241, 241);
              margin-left: ${rpx(15)}px;
              padding-right: ${rpx(15)}px;
            `}
          />
        ),
      )}
    </Section>
  );
});

const useStyles = () => {
  const { rpx } = useResponsiveContext();
  return useMemo(
    () => ({
      serviceSubject: {
        name: {
          fontSize: rpx(16),
          color: 'rgb(102, 102, 102)',
          fontFamily: FontFamily.NotoSans.Medium,
        },
        label: {
          fontSize: rpx(12),
        },
      },
    }),
    [rpx],
  );
};
